
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ProjectsNavbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/629c9343645c6844591b8b96cb81f5f4/a8f8b5c882432f4c1a0b17d9e5ef2291.jpeg"
              alt="PACKTO Smart Solutions"
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              Inicio
            </Link>
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              Soluciones
            </Link>
            <span
              className={`text-sm font-medium whitespace-nowrap ${
                scrolled ? 'text-orange-500' : 'text-orange-400'
              }`}
            >
              Proyectos
            </span>
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              Equipo
            </Link>
            <Link
              to="/"
              className="px-6 py-2.5 bg-gradient-to-r from-orange-500 to-green-500 text-white text-sm font-semibold rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Contacto
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
